import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  adminInfo: {},
  sendingRecordsToChatbot: false,
  chatbotRecords: false,
  isAddGoalsRequesting: false,
  isGoalsAdded: false,
  loadingPreviousGoals: false,
  adminPreviousgoals: {},
  isAddUnitsRequesting: false,
  isUnitsAdded: false,
  loadingPreviousUnits: false,
  adminPreviousUnits: {},
  isResetPasswordRequesting: false,
  isPasswordReset: false,
  loadingGympassHistory: false,
  gympassHistoryData: {},
  error: null,
};

const adminLoginRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    error: null,
  };
};

const adminLoginSuccess = (state = INITIAL_STATE, { adminInfo }) => {
  return {
    ...state,
    adminInfo,
    isRequesting: false,
  };
};

const adminLoginFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    error,
  };
};

const adminLogoutSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: false,
    adminInfo: {},
  };
};

const adminAddGoalsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isAddGoalsRequesting: true,
    isGoalsAdded: false,
    error: null,
  };
};

const adminAddGoalsSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isGoalsAdded: true,
    isAddGoalsRequesting: false,
  };
};

const adminAddGoalsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isAddGoalsRequesting: false,
    isGoalsAdded: false,
    error,
  };
};

const adminGetGoalsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingPreviousGoals: true,
    error: null,
  };
};

const adminGetGoalsSuccess = (state = INITIAL_STATE, { adminPreviousgoals }) => {
  return {
    ...state,
    adminPreviousgoals,
    loadingPreviousGoals: false,
  };
};

const adminGetGoalsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingPreviousGoals: false,
    error,
  };
};

const adminAddUnitsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isAddUnitsRequesting: true,
    isUnitsAdded: false,
    error: null,
  };
};

const adminAddUnitsSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isUnitsAdded: true,
    isAddUnitsRequesting: false,
  };
};

const adminAddUnitsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isAddUnitsRequesting: false,
    isUnitsAdded: false,
    error,
  };
};

const adminGetUnitsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingPreviousUnits: true,
    error: null,
  };
};

const adminGetUnitsSuccess = (state = INITIAL_STATE, { adminPreviousUnits }) => {
  return {
    ...state,
    adminPreviousUnits,
    loadingPreviousUnits: false,
  };
};

const adminGetUnitsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingPreviousUnits: false,
    error,
  };
};

const adminResetPasswordRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isResetPasswordRequesting: true,
    isPasswordReset: false,
    error: null,
  };
};

const adminResetPasswordSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isPasswordReset: true,
    isResetPasswordRequesting: false,
  };
};

const adminResetPasswordFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isResetPasswordRequesting: false,
    isPasswordReset: false,
    error,
  };
};

const adminGympassHistoryRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingGympassHistory: true,
    error: null,
  };
};

const adminGympassHistorySuccess = (state = INITIAL_STATE, { gympassHistoryData }) => {
  return {
    ...state,
    gympassHistoryData,
    loadingGympassHistory: false,
  };
};

const adminGympassHistoryFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingGympassHistory: false,
    error,
  };
};

export const HANDLERS = {
  [Types.ADMIN_LOGIN_REQUEST]: adminLoginRequest,
  [Types.ADMIN_LOGIN_SUCCESS]: adminLoginSuccess,
  [Types.ADMIN_LOGIN_FAILURE]: adminLoginFailure,

  [Types.ADMIN_LOGOUT_REQUEST]: adminLoginRequest,
  [Types.ADMIN_LOGOUT_SUCCESS]: adminLogoutSuccess,
  [Types.ADMIN_LOGOUT_FAILURE]: adminLoginFailure,

  [Types.ADMIN_ADD_GOALS_REQUEST]: adminAddGoalsRequest,
  [Types.ADMIN_ADD_GOALS_SUCCESS]: adminAddGoalsSuccess,
  [Types.ADMIN_ADD_GOALS_FAILURE]: adminAddGoalsFailure,

  [Types.ADMIN_GET_GOALS_REQUEST]: adminGetGoalsRequest,
  [Types.ADMIN_GET_GOALS_SUCCESS]: adminGetGoalsSuccess,
  [Types.ADMIN_GET_GOALS_FAILURE]: adminGetGoalsFailure,

  [Types.ADMIN_ADD_UNITS_REQUEST]: adminAddUnitsRequest,
  [Types.ADMIN_ADD_UNITS_SUCCESS]: adminAddUnitsSuccess,
  [Types.ADMIN_ADD_UNITS_FAILURE]: adminAddUnitsFailure,

  [Types.ADMIN_GET_UNITS_REQUEST]: adminGetUnitsRequest,
  [Types.ADMIN_GET_UNITS_SUCCESS]: adminGetUnitsSuccess,
  [Types.ADMIN_GET_UNITS_FAILURE]: adminGetUnitsFailure,

  [Types.ADMIN_RESET_PASSWORD_REQUEST]: adminResetPasswordRequest,
  [Types.ADMIN_RESET_PASSWORD_SUCCESS]: adminResetPasswordSuccess,
  [Types.ADMIN_RESET_PASSWORD_FAILURE]: adminResetPasswordFailure,

  [Types.ADMIN_GYMPASS_HISTORY_REQUEST]: adminGympassHistoryRequest,
  [Types.ADMIN_GYMPASS_HISTORY_SUCCESS]: adminGympassHistorySuccess,
  [Types.ADMIN_GYMPASS_HISTORY_FAILURE]: adminGympassHistoryFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
